<script>
import {h, resolveComponent} from 'vue';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';

import {CHART} from '@/components/constants/chart';
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  name: 'widgetChartLine',
  emits: ['more'],
  mixins: [i18nMixin],
  components: {widgetWrapper, 'v-chart': ECharts},
  render() {
    const {items} = this;
    const {title, subtitle, dateItem, more, info, errorMessage} = items;
    const legoIcon = resolveComponent('lego-icon');
    const cLabel = resolveComponent('c-label');
    const vChart = resolveComponent('v-chart');
    const widgetWrapper = resolveComponent('widget-wrapper');
    const nullWidget = h('div', {class: ['widget-null']}, [
      h(legoIcon, {
        iconType: 'df',
        icon: 'exclamation_circle',
        size: 72,
        color: '#D6DCF4'
      }),
      h(
          cLabel,
          {
            size: 20,
            weight: 500
          },
          [errorMessage || this.t('label.noData')]
      )
    ]);

    const widgetChartBar =
        items.data.length > 0
            ? h(vChart, {
              autoresize: true,
              option: this.buildOption(),
              style: [{width: '100%', height: '100%'}]
            })
            : nullWidget;

    return h(
        widgetWrapper,
        {
          title,
          subtitle,
          dateItem,
          more,
          info,
          onMore: (more) => {
            this.$emit('more', more);
          }
        },
        () => [widgetChartBar]
    );
  },
  props: {
    items: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    buildOption() {
      const {$theme, items} = this;

      const series = this.items.data.map((seriesData, idx) => ({
        value: seriesData,
        name: items.xAxisData[idx],
        cursor: 'default',
        itemStyle: {color: $theme.COLOR.CHART[0]}
      }));

      const option = {
        title: {
          subtext: this.items.unit
        },
        xAxis: [{data: items.xAxisData}],
        series: {
          data: series,
          lineStyle: {
            color: $theme.COLOR.CHART[0]
          }
        }
      };

      return _.merge({}, CHART.CHART_LINE, option);
    }
  }
};
</script>

<style scoped lang="scss">
.widget-chart-bar {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
}

.widget-null {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;

  :deep.lego-icon {
    margin-bottom: 17px;
  }
}
</style>
